import { axiosWorkflow as axiosClient } from 'lib/axiosClient';

export const getDetailedWorkflow = ({ workflowId }) => {
	return axiosClient.get(`los/workflows/${workflowId}`);
};
